import { render, staticRenderFns } from "./KStepper.vue?vue&type=template&id=605eaa80&lang=pug"
import script from "./KStepper.vue?vue&type=script&lang=js"
export * from "./KStepper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports